export default "__VITE_ASSET__2v88wxH7__"